import { parseAiffBuffer } from "@/utils/audio/aiff/parseAiff";

export const getAiffDuration = async (aiffFile: File): Promise<number> => {
  const arrayBuffer = await aiffFile.arrayBuffer();
  const aiffData = parseAiffBuffer(arrayBuffer);
  return aiffData.duration;
};
